export default __webpack_public_path__ + "static/media/26.9ebecb58.jpg";